<script setup>
/* Übergangsanzeige für die Reiter, die noch nicht umgestellt sind.
 *
 * Bewusst als ehrlicher Hinweis statt als leere Fläche: Ein leerer Bereich
 * sieht aus wie ein Fehler oder wie "keine Daten vorhanden" — beides wäre
 * hier falsch. Die Daten sind da, nur die Darstellung fehlt noch.
 *
 * Diese Datei verschwindet, sobald der letzte Reiter umgestellt ist.
 */
defineProps({
  tab: { type: String, required: true },
});
</script>

<template>
  <div class="placeholder">
    <div class="ph-icon">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" stroke-linejoin="round" />
        <path d="M14 3v5h5" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="ph-title">{{ $t(`tabs.${tab === 'transfer' ? 'transferInfo' : tab}`) }}</div>
    <p class="ph-text">{{ $t('sector.notMigrated') }}</p>
  </div>
</template>

<style scoped>
.placeholder {
  padding: 44px 20px;
  text-align: center;
  background: var(--card);
  border: 1px dashed var(--border);
  border-radius: 12px;
}
.ph-icon {
  color: var(--dim);
  margin-bottom: 12px;
}
.ph-title {
  font-family: var(--display);
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 6px;
}
.ph-text {
  font-size: 0.8rem;
  color: var(--muted);
  line-height: 1.6;
  max-width: 340px;
  margin: 0 auto;
}
</style>
